import { MuiThemeComponentsType } from '../types';

export default (): MuiThemeComponentsType['MuiTabs'] => ({
  styleOverrides: {
    indicator: {
      height: '4px',
    },
  },
});
